<template>
  <div class="znzz">
    <div class="header">
    </div>
    <iframe class="iframe" src="https://www.cz-icloud.com/solutionList?onlyView=true"></iframe>
  </div>
</template>

<script>



export default {
  name: "",
  components:{
  },
  data(){
    return  {

    }
  },
  created() {
  },
  methods:{

  }
}
</script>

<style lang="scss" scoped>

.znzz{
  background: #fff;
}

.header{
  height: 68px;
  &:before{
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 68px;
    background:rgba(0,111,240,0.5)!important;
  }
}
.iframe{
  width: 100%;
  min-height: calc(100vh - 70px);
  border: none;
}
</style>